import { createSelector } from 'reselect';

const selectRaw = (state) => state.gestorDocumental.view;

const selectRecord = createSelector(
  [selectRaw],
  (raw) => raw.record,
);

const selectLoading = createSelector([selectRaw], (raw) =>
  Boolean(raw.loading),
);

const gestorDocumentalViewSelectors = {
  selectLoading,
  selectRecord,
  selectRaw,
};

export default gestorDocumentalViewSelectors;
